import { render } from "./NotFoundComponent.vue?vue&type=template&id=658169d1"
const script = {}
script.render = render

export default script